import { PermissionTableOperation } from '@modules/users/types';
import { PermissionOperation } from 'generated/graphql';

export const getPermissionTableOperation = (
  operation: PermissionOperation,
): PermissionTableOperation => {
  switch (operation) {
    case PermissionOperation.Read:
      return PermissionTableOperation.View;
    case PermissionOperation.Write:
      return PermissionTableOperation.Edit;
    default:
      return PermissionTableOperation.None;
  }
};
